import { render } from "./LegalBasisSection.vue?vue&type=template&id=394f30b0"
import script from "./LegalBasisSection.vue?vue&type=script&lang=js"
export * from "./LegalBasisSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__